import BaseStore from 'vendor/cnpm/fluxible.v0-4/addons/BaseStore';

class ThreadSettingsStore extends BaseStore {
  static storeName = 'ThreadSettingsStore';

  static handlers = {
    ADD_THREAD: 'onAddThread',
    CLOSE_THREAD: 'onCloseThread',
    UNCLOSE_THREAD: 'onUncloseThread',
    PIN_THREAD: 'onPinThread',
    UNPIN_THREAD: 'onUnpinThread',
    THREAD_SETTINGS_ERROR: 'onError',
  };

  threadInfo = {};

  errorMessage = null;

  onAddThread(threadInfo: $TSFixMe) {
    this.errorMessage = null;
    this.threadInfo = threadInfo;
    this.emitChange();
  }

  onCloseThread() {
    this.errorMessage = null;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'state' does not exist on type '{}'.
    if (this.threadInfo.state) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'state' does not exist on type '{}'.
      this.threadInfo.state.closed = true;
    }
    this.emitChange();
  }

  onUncloseThread() {
    this.errorMessage = null;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'state' does not exist on type '{}'.
    if (this.threadInfo.state) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'state' does not exist on type '{}'.
      this.threadInfo.state.closed = false;
    }
    this.emitChange();
  }

  onPinThread() {
    this.errorMessage = null;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'state' does not exist on type '{}'.
    if (this.threadInfo.state) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'state' does not exist on type '{}'.
      this.threadInfo.state.pinned = true;
    }
    this.emitChange();
  }

  onUnpinThread() {
    this.errorMessage = null;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'state' does not exist on type '{}'.
    if (this.threadInfo.state) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'state' does not exist on type '{}'.
      this.threadInfo.state.pinned = false;
    }
    this.emitChange();
  }

  onError(errorMessage: $TSFixMe) {
    this.errorMessage = errorMessage;
    this.emitChange();
  }

  isClosed() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'state' does not exist on type '{}'.
    return !!(this.threadInfo.state && (this.threadInfo.state.closed || false));
  }

  isPinned() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'state' does not exist on type '{}'.
    return !!(this.threadInfo.state && (this.threadInfo.state.pinned || false));
  }

  getQuestionId() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type '{}'.
    return this.threadInfo.id;
  }

  getForumType() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'forumType' does not exist on type '{}'.
    return this.threadInfo.forumType;
  }

  isError() {
    return !!this.errorMessage;
  }
}

export default ThreadSettingsStore;
